import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win = window;
let lang;

if (window.location.href.includes("localhost")) {
  lang = "ar";
} else {
  lang = document.documentElement.lang;
}

const rtl = lang === "ar";
!!!win["lang"] && (win["lang"] = lang);
document.documentElement.lang = lang;
document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
const dir = lang === null || lang === "en" ? "ltr" : "rtl";

const initialState = {
  rtl,
  dir,
  lang,
  loading: true,
  center: {},
  msisdn: '',
  refId: '',
  smsSentTo: '',
  page: 'map',
  gisZone: {},
  coverageLoading: false,
  mapData: { address: '', latLng: ''},
  formData: {},
  LeadRequestId: ''
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADER":
      return {
        ...state,
        loading: action.payload,
      };

    case "SET_CENTER":
      return {
        ...state,
        center: action.payload.center,
      };

    case "SET_MSISDN":
      return {
        ...state,
        msisdn: action.payload.msisdn,
        refId: action.payload.refId,
        smsSentTo: action.payload.smsSentTo,
      };
    
    case "UPDATE_GIS_ZONE":
      return {
        ...state,
        gisZone: action.payload.data,
      };
    case "UPDATE_PAGE":
      return {
        ...state,
        page: action.payload,
      };
    case "UPDATE_LEAD_REQUESTID":
      return {
        ...state,
        LeadRequestId: action.payload,
      };
    case "CURRENT_MAP_VALUE":
      return {
        ...state,
        mapData: action.payload
      }
    case "FORM_DATA":
      return {
        ...state,
        formData: action.payload
      }
    default:
      return state;
  }
};

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
